import React from "react";
import {Button} from "@material-ui/core";
import {IoCloseOutline, IoPrintOutline} from "react-icons/io5";
import {useEffect} from "react";
import {useState} from "react";
import {useRef} from "react";
import {Text} from "Constants";
import PhoneInput from "react-phone-input-2";
import {ParseError, parsePhoneNumberWithError, parsePhoneNumberFromString, format} from "libphonenumber-js";
import {jsPDF} from "jspdf";
import ubmeLogo from "../../../../../../images/ubme_logo.png";

const UpdateAttendeeModal = ({
                                 editAdditionalInfo,
                                 AttendeeUpdate,
                                 isOpen,
                                 eventName
                             }) => {
    // Extract data from props
    const {
        TotalCounts,
        Title,
        Status,
        OrderDate,
        EventId,
        PdfFile,
        OrderId,
        ScannedDateTime,
        QRCode,
        IsAnonymousAllowed,
        ...restinfo
    } = editAdditionalInfo;

    // Initialize state variables
    const [isNotFilled, setIsNotFilled] = useState(false);
    const [phoneError, setPhoneError] = useState("");
    const [phoneNumber, setPhoneNumber] = useState('');
    const [selectedCountry, setSelectedCountry] = useState(''); // Default country code

    const DEFAULT_COUNTRY_CODE = '1'; // Replace with your desired default country code

    // Initialize updatedInfo state
    const updatedInfoInitialState = Object.keys(restinfo).map((key, index) => {
        return {
            FieldName: key,
            DefaultValue: restinfo[key],
            id: index.toString(),
        };
    });

    // Define handleChangeAdd function
    // const handleChangeAdd = (e) => {
    //     let {name, value, id} = e.target;
    //     let newData = [...updatedInfo];
    //
    //     // Validation for full name
    //     if (name === "FullName") {
    //         if (!/^(?=.*[A-Za-z])[\w\s'-]+ [A-Za-z\d\s'-]+$/.test(value)) {
    //             // If the entered value doesn't match the pattern, handle it accordingly
    //             setIsNotFilled(true);
    //             newData[id]["IsValid"] = false;
    //             newData[id]["ErrorMessage"] = "Please enter a valid first and last name.";
    //         } else {
    //             setIsNotFilled(false);
    //             newData[id]["IsValid"] = true;
    //             newData[id]["ErrorMessage"] = "";
    //         }
    //     } else if (name === "Email") {
    //         // Validation for email
    //         // You can use a regular expression or any other method to validate the email format
    //         // Here, I'm using a simple format validation for demonstration
    //         if (!/\S+@\S+\.\S+/.test(value)) {
    //             setIsNotFilled(true);
    //             newData[id]["IsValid"] = false;
    //             newData[id]["ErrorMessage"] = "Please enter a valid email address.";
    //
    //         } else {
    //             setIsNotFilled(false);
    //             newData[id]["IsValid"] = true;
    //             newData[id]["ErrorMessage"] = "";
    //         }
    //     }
    //
    //     newData[id]["DefaultValue"] = value;
    //     setUpdatedInfo(newData);
    // };

    const handleChangeAdd = (e) => {
        let { name, value, id } = e.target;
        let newData = [...updatedInfo]; // Clone state

        if (id.startsWith("exotic-input-")) {
            // Handle ExoticFields
            let exoticFieldIndex = newData.findIndex((item) => item.FieldName === "ExoticFields");

            if (exoticFieldIndex !== -1) {
                let exoticFields = JSON.parse(JSON.stringify(newData[exoticFieldIndex].DefaultValue)); // Deep clone

                if (exoticFields[name]) {
                    exoticFields[name].SelectedValue = value; // Update selected value
                }

                newData[exoticFieldIndex] = {
                    ...newData[exoticFieldIndex],
                    DefaultValue: exoticFields,
                };
            }
        } else {
            // Handle normal fields
            let fieldIndex = newData.findIndex((item) => item.FieldName === name);
            if (fieldIndex !== -1) {
                let updatedField = { ...newData[fieldIndex] }; // Clone field

                // Validation
                if (name === "FullName") {
                    updatedField.IsValid = /^(?=.*[A-Za-z])[\w\s'-]+ [A-Za-z\d\s'-]+$/.test(value);
                    updatedField.ErrorMessage = updatedField.IsValid ? "" : "Please enter a valid first and last name.";
                } else if (name === "Email") {
                    updatedField.IsValid = /\S+@\S+\.\S+/.test(value);
                    updatedField.ErrorMessage = updatedField.IsValid ? "" : "Please enter a valid email address.";
                }

                updatedField.DefaultValue = value;
                newData[fieldIndex] = updatedField; // Update the specific field
            }
        }

        setUpdatedInfo(newData);
    };

    const handleInput = (e) => {
        e.target.style.height = 'auto'; // Reset height
        e.target.style.height = `${e.target.scrollHeight}px`; // Set height based on scroll height
        handleChangeAdd(e); // Call the existing handleChange function to handle other logic
    };

    // Define handlePhoneNumberChange function
    const handlePhoneNumberChange = (value, country) => {
        try {
            const cleanedValue = value.replace(/\D/g, "");

            if (!cleanedValue) {
                setPhoneNumber("");
                setIsNotFilled(true);
                setPhoneError("Phone number is required.");
                return;
            }

            const internationalNumber = `+${cleanedValue}`;

            // Keep +1 in the input value.
            setPhoneNumber(internationalNumber);

            if (cleanedValue.length < 6) {
                setIsNotFilled(true);
                setPhoneError("Please enter a valid phone number.");
                return;
            }

            const phoneNumberObject = parsePhoneNumberWithError(
                internationalNumber,
                country.countryCode.toUpperCase()
            );

            if (phoneNumberObject && phoneNumberObject.isValid()) {
                setIsNotFilled(false);
                setPhoneError("");

                const newData = [...updatedInfo];

                const foundObject = newData.find(
                    (item) => item.FieldName === "Phone"
                );

                if (foundObject) {
                    foundObject.DefaultValue = internationalNumber;
                }

                setUpdatedInfo(newData);
            } else {
                setIsNotFilled(true);
                setPhoneError("Please enter a valid phone number.");
            }

        } catch (error) {
            console.error(error);

            setIsNotFilled(true);
            setPhoneError("Please enter a valid phone number.");
        }
    };

    // Initialize updatedInfo state
    const [updatedInfo, setUpdatedInfo] = useState(updatedInfoInitialState);

    let obj = {};
    updatedInfo.map(({ FieldName, DefaultValue }) =>
        Object.assign(obj, {
            [FieldName.replace(/\s/g, FieldName === "Full Name" ? "" : "_")]:
            DefaultValue,
        })
    );

    obj.Phone = obj?.Phone?.replace(/[^\d]+/g, "");
    if (obj.hasOwnProperty("TermsAndConditions")) {
        let specialChars =
            /[\\"/\#\$\%\&\(\)\*\+\,\-\.\:\;\<\=\>\?\@\[\]\^\`\{\|\}\~\'\!]/g;
        obj.TermsAndConditions = obj.TermsAndConditions.replace(
            specialChars,
            "\\$&"
        );
    }

    // Remove specified properties from obj
    delete obj.Amount;
    delete obj.BookingDate;
    delete obj.BookingTime;
    delete obj.CurrencyCode;
    delete obj.CurrencySymbol;
    delete obj.DiscountAmount;
    delete obj.DiscountCode;
    delete obj.Price;
    delete obj.Re_ScannedDateTime;
    delete obj.RecurringInterval;
    delete obj.RecurringTicket;
    delete obj.TaxAmount;
    delete obj.TaxName;
    delete obj.UBMeFeeAmount;
    delete obj.isAbsorb;
    delete obj.Terms_And_Conditions;
    delete obj.TermsAndConditions;
    delete obj.SlotPerBundle;
    delete obj.isBundle;
    delete obj.TicketDescription;
    delete obj.Notes;
    delete obj.UserId;
    delete obj.IsAnonymousAllowed;

    useEffect(() => {

        // Check if "Phone" field exists and get its default value
        const phoneInfo = updatedInfo?.find((i) => i.FieldName === "Phone");
        let phoneValue = phoneInfo ? phoneInfo.DefaultValue : '';

        try {
            // Use libphonenumber-js to parse the phone number
            let phoneNumberObject = parsePhoneNumberFromString(phoneValue);

            if (!phoneNumberObject) {
                let phoneValueWithPlus = "+" + phoneValue
                phoneNumberObject = parsePhoneNumberFromString(phoneValueWithPlus);

                if(!phoneNumberObject) {
                    let phoneValueWithPlusWithDefaultCode = "+" + DEFAULT_COUNTRY_CODE + phoneValue
                    phoneNumberObject = parsePhoneNumberFromString(phoneValueWithPlusWithDefaultCode);

                    if (phoneNumberObject) {
                        phoneValue =  phoneNumberObject.formatInternational()
                    }
                } else if (!phoneNumberObject.isValid()) {
                    let phoneValueWithPlusWithDefaultCode = "+" + DEFAULT_COUNTRY_CODE + phoneValue
                    phoneNumberObject = parsePhoneNumberFromString(phoneValueWithPlusWithDefaultCode);

                    if (phoneNumberObject) {
                        phoneValue =  phoneNumberObject.formatInternational()
                    }
                } else {
                    phoneValue =  phoneNumberObject.formatInternational()
                }
            }

            // Format the phone number in international format
            phoneValue =  phoneNumberObject.formatInternational()
        } catch (error) {
            // Handle any errors here
            console.error('Error formatting phone number:', error);
            return phoneValue;
        }

        const fieldsToExcludeFromValidation = [
            "Amount",
            "BookingDate",
            "BookingTime",
            "CurrencyCode",
            "CurrencySymbol",
            "DiscountAmount",
            "DiscountCode",
            "Price",
            "Re_ScannedDateTime",
            "RecurringInterval",
            "RecurringTicket",
            "TaxAmount",
            "TaxName",
            "UBMeFeeAmount",
            "isAbsorb",
            "Terms_And_Conditions",
            "TermsAndConditions",
            "SlotPerBundle",
            "isBundle",
            "TicketDescription",
            "Notes",
            "UserId",
            "IsAnonymousAllowed",
            "AddOns",
            "AddonGroupId",
            "IsCardProcessingFeeAbsorb",
            "CardProcessingFeeAmount",
            "PaymentMethod",
            "OrderStatus"
        ];

        const isNotFilled = updatedInfo?.some(
            (i) =>
                !fieldsToExcludeFromValidation.includes(i.FieldName) &&
                i.DefaultValue === ""
        );

        setIsNotFilled(isNotFilled);

        // Set the phoneNumber state
        setPhoneNumber(phoneValue);
    }, [updatedInfo]);

    // Create refs for each textarea/input
    const refs = useRef([]);

    // Set initial height for each textarea based on its content
    useEffect(() => {
        refs.current.forEach((ref) => {
            if (ref && ref.tagName === 'TEXTAREA') { // Ensure we only apply this to textareas
                ref.style.height = 'auto'; // Reset height to auto to calculate the correct height
                ref.style.height = `${ref.scrollHeight}px`; // Set height based on scrollHeight
            }
        });
    }, [updatedInfo]); // Run whenever updatedInfo changes

    const formatPhoneNumber = (phoneValue) => {

        try {
            // Use libphonenumber-js to parse the phone number
            let phoneNumberObject = parsePhoneNumberFromString(phoneValue);

            if (!phoneNumberObject) {
                let phoneValueWithPlus = "+" + phoneValue
                phoneNumberObject = parsePhoneNumberFromString(phoneValueWithPlus);

                if(!phoneNumberObject) {
                    let phoneValueWithPlusWithDefaultCode = "+" + DEFAULT_COUNTRY_CODE + phoneValue
                    phoneNumberObject = parsePhoneNumberFromString(phoneValueWithPlusWithDefaultCode);

                    if (phoneNumberObject) {
                        phoneValue =  phoneNumberObject.formatInternational()
                    }
                } else if (!phoneNumberObject.isValid()) {
                    let phoneValueWithPlusWithDefaultCode = "+" + DEFAULT_COUNTRY_CODE + phoneValue
                    phoneNumberObject = parsePhoneNumberFromString(phoneValueWithPlusWithDefaultCode);

                    if (phoneNumberObject) {
                        phoneValue =  phoneNumberObject.formatInternational()
                    }
                } else {
                    phoneValue =  phoneNumberObject.formatInternational()
                }
            }

            // Format the phone number in international format
            phoneValue =  phoneNumberObject.formatInternational()
        } catch (error) {
            // Handle any errors here
            console.error('Error formatting phone number:', error);
            return phoneValue;
        }

        return phoneValue;
    };

    const generatePDF = async (details) => {
        const doc = new jsPDF();

        // Add the image (assuming it's a local image or base64)
        const img = new Image();
        img.src = ubmeLogo;

        // Fields to exclude from the PDF
        const fieldsToExclude = [
            "TotalCounts", "Title", "Status", "OrderDate", "EventId", "PdfFile", "OrderId",
            "ScannedDateTime", "QRCode", "Amount", "BookingDate", "BookingTime", "CurrencyCode",
            "CurrencySymbol", "DiscountAmount", "DiscountCode", "Price", "Re_ScannedDateTime",
            "RecurringInterval", "RecurringTicket", "TaxAmount", "TaxName", "UBMeFeeAmount",
            "isAbsorb", "Terms_And_Conditions", "TermsAndConditions", "SlotPerBundle", "isBundle",
            "TicketDescription", "Notes", "UserId", "IsAnonymousAllowed", "ExoticFields", "IsCardProcessingFeeAbsorb", "CardProcessingFeeAmount", "PaymentMethod", "OrderStatus"
        ];

        // Filter out excluded fields
        const filteredDetails = Object.keys(details)
            .filter(key => !fieldsToExclude.includes(key))
            .reduce((obj, key) => {
                obj[key] = details[key];
                return obj;
            }, {});

        // Prioritize FullName, Email, and Phone at the top
        const orderedFields = [
            "FullName", "Email", "Phone",
            ...Object.keys(filteredDetails).filter(key => !["FullName", "Email", "Phone"].includes(key))
        ];

        img.onload = () => {
            const imgWidth = 40;
            const imgHeight = (img.height * imgWidth) / img.width;
            const imgX = (doc.internal.pageSize.width - imgWidth) / 2;
            const imgY = 10;

            doc.addImage(img, 'JPEG', imgX, imgY, imgWidth, imgHeight);

            // Add the Event Name (Title)
            const title = details?.Title || "Event";
            doc.setFontSize(16);
            doc.setFont("helvetica", "bold");
            const titleY = imgY + imgHeight + 10;
            doc.text(title, doc.internal.pageSize.width / 2, titleY, { align: "center" });

            // Add Order Date (if available)
            const orderDateTime = details?.OrderDate || "";
            doc.setFontSize(10);
            doc.setFont("helvetica", "normal");
            doc.setTextColor(128, 128, 128);
            const dateTimeY = titleY + 6;
            doc.text(orderDateTime, doc.internal.pageSize.width / 2, dateTimeY, { align: "center" });

            // Reset text color to black
            doc.setTextColor(0, 0, 0);

            // Start position for the details
            let y = dateTimeY + 15;
            const pageHeight = doc.internal.pageSize.height;
            const leftColumnX = 20;
            const maxLineWidth = 160;
            const padding = 1;
            const extraSpaceAfterAnswer = 7;

            doc.setFontSize(12);

            // Loop through standard fields and add to PDF
            orderedFields.forEach((key) => {
                if (filteredDetails[key]) {
                    let answer = filteredDetails[key].toString();
                    if (key === "Phone") {
                        answer = formatPhoneNumber(answer);
                    }
                    const question = key === "FullName" ? "Full Name" : key.replace(/_/g, " ");

                    // Split text into multiple lines if too long
                    const questionLines = doc.splitTextToSize(question, maxLineWidth);
                    const questionHeight = questionLines.length * 6;
                    const answerLines = doc.splitTextToSize(answer, maxLineWidth);
                    const answerHeight = answerLines.length * 6;

                    // Check if new page is needed
                    if (y + questionHeight + answerHeight + padding + extraSpaceAfterAnswer > pageHeight) {
                        doc.addPage();
                        y = 20;
                    }

                    // Add question (bold)
                    doc.setFont("helvetica", "bold");
                    doc.text(questionLines, leftColumnX, y);

                    y += questionHeight + 2;

                    // Add answer (normal font)
                    doc.setFont("helvetica", "normal");
                    doc.text(answerLines, leftColumnX, y);

                    y += answerHeight + padding + extraSpaceAfterAnswer;
                }
            });

            // ✅ Include Exotic Fields
            const exoticFields = details?.ExoticFields || {};
            Object.keys(exoticFields).forEach((key) => {
                const field = exoticFields[key];

                if (field?.SelectedValue) {
                    const question = key.replace(/_/g, " "); // Format key as question
                    const answer =  Array.isArray(field.SelectedValue) ? field.SelectedValue.join(", ").toString() : field.SelectedValue.toString()? field.SelectedValue.toString() : ""; // Convert answer to string

                    // Check if a new page is needed
                    if (y + 12 > pageHeight) {
                        doc.addPage();
                        y = 20;
                    }

                    // Add Exotic Field question
                    doc.setFont("helvetica", "bold");
                    doc.text(question, leftColumnX, y);
                    y += 6;

                    // Add Exotic Field answer
                    doc.setFont("helvetica", "normal");
                    doc.text(answer, leftColumnX, y);
                    y += 10;
                }
            });

            // Save PDF with Full Name
            const fullName = details?.FullName || "output";
            doc.save(`${fullName}.pdf`);
        };
    };

    return (
        <div className="UpdateAttendeeModal">
            <div>
                <div className="edit_container">
                    <div style={{padding: 10}} className="edit_container_close_btn">
                        <IoCloseOutline
                            size={25}
                            color="rgba(0, 0, 0, 0.54)"
                            onClick={isOpen}
                        />
                    </div>
                    <p className="edit_container_header">Edit Attendee</p>
                    <div style={{padding: 10}} className="edit_container_close_btn">
                        <IoPrintOutline
                            size={25}
                            color="rgba(0, 0, 0, 0.54)"
                            onClick={() => generatePDF(editAdditionalInfo)}
                        />
                    </div>
                </div>

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                    }}
                    className="modalDetail"
                >
                    <div className="modalForm">
                        {updatedInfo?.map(({FieldName, FormFieldId, DefaultValue, IsValid, ErrorMessage}, index) =>
                                FieldName === "Terms_And_Conditions" ||
                                FieldName === "TermsAndConditions"
                                    ? null
                                    :
                                    ![
                                        "Amount",
                                        "BookingDate",
                                        "BookingTime",
                                        "CurrencyCode",
                                        "CurrencySymbol",
                                        "DiscountAmount",
                                        "DiscountCode",
                                        "Price",
                                        "Re_ScannedDateTime",
                                        "RecurringInterval",
                                        "RecurringTicket",
                                        "TaxAmount",
                                        "TaxName",
                                        "UBMeFeeAmount",
                                        "isAbsorb",
                                        "Terms_And_Conditions",
                                        "TermsAndConditions",
                                        "SlotPerBundle",
                                        "isBundle",
                                        "TicketDescription",
                                        "Notes",
                                        "UserId",
                                        "IsAnonymousAllowed",
                                        "ExoticFields",
                                        "AddOns",
                                        "AddonGroupId",
                                        "IsCardProcessingFeeAbsorb",
                                        "CardProcessingFeeAmount",
                                        "PaymentMethod",
                                        "OrderStatus"
                                    ].includes(FieldName)  &&
                                    (
                                        <div style={{
                                            position: "relative",
                                            marginBottom: 20,
                                        }}>
                                            <p
                                                style={{
                                                    fontSize: 14,
                                                    fontWeight: 400,
                                                    marginBottom: 8,
                                                }}
                                            >
                                                {FieldName === "FullName"
                                                    ? "Full Name"
                                                    : FieldName?.replace(/_/g, " ")}{" "}
                                                {(FieldName === "FullName" || FieldName === "Email" || FieldName === "Phone") && (
                                                    <span
                                                        style={{
                                                            color: "red",
                                                            fontSize: "medium",
                                                        }}
                                                    >
                                                        *
                                                    </span>
                                                )}
                                            </p>

                                            {FieldName === "Phone" ? (
                                                <div style={{
                                                    paddingLeft: "2%",
                                                    border: "2px solid #d8d8d8",
                                                    borderRadius: "5px",
                                                    outlineColor: "#fff",
                                                }}
                                                >
                                                    <div className="phone-input-container">
                                                        <PhoneInput
                                                            country={selectedCountry || 'us'}
                                                            value={phoneNumber}
                                                            onChange={handlePhoneNumberChange}
                                                            inputProps={{
                                                                name: 'phone',
                                                                required: true,
                                                            }}
                                                            containerStyle={{
                                                                borderWidth: 0
                                                            }}
                                                            inputStyle={{
                                                                border: 'none',
                                                                marginLeft: '50px',
                                                                width: '80%'
                                                            }}
                                                            enableSearch={true}
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                <div style={{
                                                    paddingLeft: "2%",
                                                    border: "2px solid #d8d8d8",
                                                    borderRadius: "5px",
                                                    outlineColor: "#fff",
                                                }}
                                                >
                                                    <div className="div-with-scroll">
                                                        {FieldName === "Full Name" || FieldName === "Email" || FieldName === "Phone" ? (
                                                            <input
                                                                className="add_info_input"
                                                                id={index.toString()}
                                                                name={FieldName}
                                                                value={DefaultValue}
                                                                key={FormFieldId}
                                                                ref={(el) => (refs.current[index] = el)} // Assign ref
                                                                type="text"
                                                                required={true}
                                                                // maxLength="260"
                                                                onChange={(e) => handleChangeAdd(e)}
                                                            />
                                                        ) : (
                                                            <textarea
                                                                className="add_info_textarea"
                                                                id={index.toString()}
                                                                name={FieldName}
                                                                value={DefaultValue}
                                                                ref={(el) => (refs.current[index] = el)} // Assign ref
                                                                key={FormFieldId}
                                                                // required={true}
                                                                onChange={(e) => handleChangeAdd(e)}
                                                                onInput={(e) => handleInput(e)}
                                                                rows="1"  // Start with a single row
                                                            />
                                                        )
                                                        }
                                                        {DefaultValue === "" && (
                                                            <label
                                                                htmlFor={index.toString()}
                                                                style={{
                                                                    position: "absolute",
                                                                    // top: "-5px",
                                                                    left: 4,
                                                                    fontSize: 15,
                                                                    margin: 0,
                                                                    fontWeight: 400,
                                                                    color: "#b1b1b1",
                                                                    paddingTop: "0.5%",
                                                                    minHeight: "33px",
                                                                }}
                                                            >
                                                                {FieldName !== "Full Name" && FieldName !== "Email" && FieldName !== "Phone" ? (
                                                                    "Type your answer"
                                                                ) : (
                                                                    <>
                                                                  <span
                                                                      style={{
                                                                          color: "red",
                                                                          fontSize: "medium",
                                                                      }}
                                                                  >
                                                                    *
                                                                  </span>{" "}
                                                                        {FieldName} {/* Correct placement of FieldName */}
                                                                    </>
                                                                )}
                                                            </label>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                            {FieldName === "Phone" && phoneError && (
                                                <div
                                                    style={{
                                                        marginTop: 10,
                                                        color: "red",
                                                        fontSize: 12
                                                    }}
                                                >
                                                    {phoneError}
                                                </div>
                                            )}
                                            {(FieldName === "FullName" || FieldName === "Email") && !IsValid && (
                                                <div style={{color: "red"}}>
                                                    {ErrorMessage}
                                                </div>
                                            )}

                                        </div>
                                    )

                        )}

                        {obj.ExoticFields &&
                            Object.entries(obj.ExoticFields).map(([FieldName, fieldData], index) => {
                                if (!fieldData || typeof fieldData !== "object") return null; // Prevent errors if fieldData is undefined

                                const { SelectedValue, FieldType, Options } = fieldData;

                                return (
                                    <div key={`exotic-${index}`} style={{ position: "relative", marginBottom: 20 }}>
                                        <p style={{ fontSize: 14, fontWeight: 400, marginBottom: 8 }}>
                                            {FieldName.replace(/_/g, " ")}{" "}
                                            {/*<span style={{ color: "red", fontSize: "medium" }}>*</span>*/}
                                        </p>

                                        <div
                                            style={{
                                                paddingLeft: "2%",
                                                border: "2px solid #d8d8d8",
                                                borderRadius: "5px",
                                                outlineColor: "#fff",
                                            }}
                                        >
                                            <div className="div-with-scroll">
                                                <input
                                                    className="add_info_input"
                                                    id={`exotic-input-${index}`}
                                                    name={FieldName}
                                                    value={Array.isArray(SelectedValue) ? SelectedValue.join(", ") : SelectedValue ? SelectedValue : ""} // Ensure it's always a string
                                                    ref={(el) => (refs.current[index] = el)} // Ensure refs is initialized
                                                    type="text"
                                                    onChange={(e) => handleChangeAdd(e)}
                                                />
                                                {SelectedValue === "" && (
                                                    <label
                                                        htmlFor={index.toString()}
                                                        style={{
                                                            position: "absolute",
                                                            // top: "-5px",
                                                            left: 4,
                                                            fontSize: 15,
                                                            margin: 0,
                                                            fontWeight: 400,
                                                            color: "#b1b1b1",
                                                            paddingTop: "0.5%",
                                                            minHeight: "33px",
                                                        }}
                                                    >
                                                        Type your answer
                                                    </label>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}

                        {/* Save & Cancel Buttons */}
                        <div
                            style={{marginTop: 15}}
                            className="detailAction"
                            id="eventCommonModal"
                        >
                            <Button
                                onClick={() => isOpen()}
                                style={{
                                    width: 120,
                                    height: 50,
                                    backgroundColor: "#fff",
                                    fontSize: "1.5rem",
                                    color: "#000000",
                                    padding: "12px 60px",
                                    borderColor: "#968e8e",
                                }}
                                className="btn_save_edit_details"
                                color={"primary"}
                                variant={"outlined"}
                                component="span"
                            >
                                {Text.Cancel}
                            </Button>

                            <Button
                                onClick={() => {
                                    const updatedPayload = {
                                        AdditionalDetails: JSON.stringify(obj),
                                        ...(IsAnonymousAllowed === 'False'
                                            ? {QRCode: QRCode}
                                            : {OrderId: OrderId}),
                                    };

                                    AttendeeUpdate(updatedPayload, IsAnonymousAllowed);
                                }}
                                disabled={isNotFilled}
                                style={{
                                    backgroundColor: isNotFilled ? "#ff91e0" : "rgb(163, 56, 164)",
                                    fontSize: "1.5rem",
                                    height: 50,
                                    color: "#fff",
                                    padding: "12px 60px",
                                    border: "none",
                                    width: 120,
                                    borderRadius: 9,
                                }}
                                className="btn_save_edit_details"
                                color={"primary"}
                                variant={"contained"}
                                component="span"
                            >
                                {Text.Save}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateAttendeeModal;
